import { Property, AppUser } from '../../../types';

export const GOOGLE_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbQXmIH_ALiWal4PpBximO5Qu0-uUPfItG3_CvEAy4gtXe6Bx7xTBJ8eNO4pzz-whEN/exec';
export const DEFAULT_GLOBAL_SCHEDULE = 'Lu-Vi 08:00-17:00; Sa 08:00-12:00';

export const buildKeyOptionDescription = (formData: any): string => {
  const keyOptionText =
    formData.llaves_quien === 'otro'
      ? `¿Quién recogerá las llaves para la visita?\nNOMBRE: ${formData.llaves_nombre || ''}\nTELEFONO: ${formData.llaves_telefono || ''}\nDOCUMENTO: ${formData.llaves_documento || ''}`
      : `¿Quién recogerá las llaves para la visita?\nBROKER`;
  return `${keyOptionText}\n\n${formData.descripcion || ''}`;
};

export const buildBrokerZohoPayload = (
  property: Property,
  formData: any,
  activeAppUser: AppUser | null,
  visitType: 'reconocimiento' | 'cliente' | null,
  finalDescription: string
) => ({
  zoho_id: activeAppUser?.id_zoho || '',
  telefono_cliente: visitType === 'cliente' ? `${formData.countryCode_cliente}${formData.celular_cliente}` : '',
  last_name: visitType === 'cliente' ? formData.last_name : '',
  nombre_cliente: visitType === 'cliente' ? formData.nombre_cliente : '',
  email_cliente: visitType === 'cliente' ? formData.email_cliente : '',
  celular_cliente: visitType === 'cliente' ? `${formData.countryCode_cliente}${formData.celular_cliente}` : '',
  document: visitType === 'cliente' ? formData.document_cliente : '',
  typeDocument: 'Cedula de ciudadania',
  tipo: property.tipoinmueble || 'Apartamento',
  precio_inmueble: property.precio_venta || 0,
  ciudad_inmueble: property.ciudad || 'Bogota',
  codigoInmueble: property.codigo,
  direccion_inmueble: property.direccion,
  localidad_inmueble: property.localidad || '',
  barrio_inmueble: property.neighborhoodName || '',
  url: `${window.location.origin}/share/${property.id}?collection=${(property as any).sourceCollection?.charAt(0) || 'c'}`,
  fecha_1: formData.fecha1,
  hora_1: formData.hora1,
  fecha_2: formData.fecha2 || '',
  hora_2: formData.hora2 || '',
  descripcion: finalDescription,
  cedula_broker: formData.cc_broker,
  nombre_broker: formData.nombre_broker,
  celular_broker: `${formData.countryCode_broker}${formData.celular_broker}`,
  email_broker: formData.email_broker,
  duenio_owner: property.owner,
  isReconocimiento: visitType === 'reconocimiento',
});

export const buildWorkflowPayload = (property: Property, formData: any, isClientView: boolean, finalDescription: string) => {
  const finalFormData = { ...formData, descripcion: finalDescription };
  if (isClientView) {
    finalFormData.nombre_cliente = formData.nombre_broker;
    finalFormData.email_cliente = formData.email_broker;
    finalFormData.celular_cliente = formData.celular_broker;
    finalFormData.countryCode_cliente = formData.countryCode_broker;
  }
  return {
    id_workflow: '78c8b5f3-d21b-44eb-bd81-20b3eb07bd01',
    method: 'post',
    request: {
      ...finalFormData,
      celular_broker: `${finalFormData.countryCode_broker}${finalFormData.celular_broker}`,
      celular_cliente: `${finalFormData.countryCode_cliente}${finalFormData.celular_cliente}`,
      document: finalFormData.document_cliente || '',
      typeDocument: 'Cedula de ciudadania',
      visita: 'Si',
      codigo: property.codigo,
      direccion: property.direccion,
      owner: property.owner,
      Description: property.descripcion,
    },
  };
};
